import { AccountList, CreateAccountForm } from '@hurdl/authentication/frontend';
import { Stack } from '@hurdl/design-system';
import { type ReactElement } from 'react';

/**
 * The account administration page: create a passwordless account, and list, disable and
 * re-enable the accounts that exist (R9.4).
 *
 * It composes the Authentication_Capability's `CreateAccountForm` and `AccountList`
 * through the capability's `./frontend` components. The panel holds no store and reaches
 * no `fetch` of its own (panel invariants 1, 2): the components reach the API through the
 * capability's store, which routes through its Generated_Client, and the operations are
 * gated administratively at the capability's routes — a request without the Permission is
 * refused there, not here.
 *
 * The one `h1` is the page's; the `main` landmark is the Layout's. The page declares no
 * visual value of its own — the composition is `Stack` and the capability's own
 * Design_System-composed components.
 */
export function AccountsPage(): ReactElement {
  return (
    <Stack gap="large">
      <Stack gap="small">
        <h1 className="font-hurdl-display text-hurdl-heading font-hurdl-semibold">
          Accounts
        </h1>
        <p className="text-hurdl-body text-hurdl-muted-foreground">
          Create passwordless accounts and manage who may sign in to the
          platform.
        </p>
      </Stack>

      <Stack gap="medium">
        <h2 className="font-hurdl-display text-hurdl-subheading font-hurdl-semibold">
          Create an account
        </h2>
        <CreateAccountForm />
      </Stack>

      <Stack gap="medium">
        <h2 className="font-hurdl-display text-hurdl-subheading font-hurdl-semibold">
          Existing accounts
        </h2>
        <AccountList />
      </Stack>
    </Stack>
  );
}
